import React from 'react';

import { StyleSheet, useWindowDimensions } from 'react-native';
import { TabView as RNTabView } from 'react-native-tab-view';

import { TabBar } from './tab-bar';
import { ITabViewProps } from './types';

const TabView: React.FC<ITabViewProps> = ({
  activeTabIndex,
  handleTabIndexChange,
  renderScene,
  tabs,
  keyboardDismissMode,
  color = 'primary',
  backgroundColor,
  animationEnabled = true,
  hideTabBar = false,
  style,
  tabBarTextProps,
}) => {
  const layout = useWindowDimensions();

  return (
    <RNTabView
      animationEnabled={animationEnabled}
      swipeEnabled={!hideTabBar && tabs.every(tab => !tab.disabled)}
      navigationState={{ index: activeTabIndex, routes: tabs }}
      renderScene={renderScene}
      renderTabBar={
        hideTabBar
          ? () => null
          : tabBarProps => (
              <TabBar
                {...tabBarProps}
                color={color}
                backgroundColor={backgroundColor}
                tabBarTextProps={tabBarTextProps}
              />
            )
      }
      onIndexChange={handleTabIndexChange}
      initialLayout={{ width: layout.width }}
      keyboardDismissMode={keyboardDismissMode}
      style={[styles.pager, style]}
    />
  );
};

const styles = StyleSheet.create({
  pager: {
    flex: 1,
  },
});

export default TabView;
